import { GET } from '../request'

export const getProfesorList = () => GET('/api/agora/personal/profesor/list')
